module.exports = __webpack_public_path__ + "media/images/landing_pages/schengen_travel-c0469b865a4877408449260cc8b38675.svg";